import React, { useState } from 'react';
import VirtualGifts from './VirtualGifts';

const GiftsDemo = () => {
  const [sentGifts, setSentGifts] = useState([]);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const handleSendGift = (gift) => {
    // Simulate sending gift
    setSentGifts(prev => [...prev, { ...gift, timestamp: new Date() }]);
    setShowSuccessMessage(true);
    
    // Hide success message after 3 seconds
    setTimeout(() => {
      setShowSuccessMessage(false);
    }, 3000);
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0f0f23 0%, #1a1a2e 50%, #16213e 100%)',
      padding: '20px',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
    }}>
      {/* Header */}
      <div style={{ textAlign: 'center', marginBottom: '30px' }}>
        <h1 style={{
          fontSize: '2.5rem',
          fontWeight: '800',
          background: 'linear-gradient(135deg, #FF6B6B 0%, #00E9FF 50%, #8A2BE2 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          marginBottom: '10px'
        }}>
          Flirteen Virtual Gifts Demo
        </h1>
        <p style={{
          color: 'rgba(255, 255, 255, 0.8)',
          fontSize: '1.1rem',
          maxWidth: '600px',
          margin: '0 auto'
        }}>
          Explore our premium virtual gift collection! Send meaningful gifts to your matches and friends to show you care.
        </p>
      </div>

      {/* Success Message */}
      {showSuccessMessage && (
        <div style={{
          position: 'fixed',
          top: '20px',
          right: '20px',
          background: 'linear-gradient(135deg, #51cf66, #40c057)',
          color: 'white',
          padding: '15px 20px',
          borderRadius: '10px',
          boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
          zIndex: 1000,
          animation: 'slideIn 0.3s ease-out'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{ fontSize: '1.2rem' }}>🎉</span>
            <span style={{ fontWeight: '600' }}>Gift sent successfully!</span>
          </div>
        </div>
      )}

      {/* Main Gift Interface */}
      <VirtualGifts onSendGift={handleSendGift} />

      {/* Gift Features Overview */}
      <div style={{
        maxWidth: '800px',
        margin: '40px auto 0',
        background: 'rgba(255, 255, 255, 0.05)',
        borderRadius: '20px',
        padding: '25px'
      }}>
        <h3 style={{
          color: 'white',
          fontSize: '1.5rem',
          fontWeight: '700',
          marginBottom: '20px',
          textAlign: 'center'
        }}>
          ✨ Premium Gift Features
        </h3>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '20px'
        }}>
          <div style={{
            background: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '15px',
            padding: '20px',
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '2.5rem', marginBottom: '10px' }}>🎭</div>
            <h4 style={{ color: 'white', marginBottom: '8px' }}>Animated Effects</h4>
            <p style={{ color: 'rgba(255, 255, 255, 0.8)', fontSize: '0.9rem' }}>
              Each gift comes with unique animations and visual effects
            </p>
          </div>

          <div style={{
            background: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '15px',
            padding: '20px',
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '2.5rem', marginBottom: '10px' }}>💎</div>
            <h4 style={{ color: 'white', marginBottom: '8px' }}>Rarity System</h4>
            <p style={{ color: 'rgba(255, 255, 255, 0.8)', fontSize: '0.9rem' }}>
              Common, Uncommon, Rare, and Legendary gifts with different values
            </p>
          </div>

          <div style={{
            background: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '15px',
            padding: '20px',
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '2.5rem', marginBottom: '10px' }}>🎯</div>
            <h4 style={{ color: 'white', marginBottom: '8px' }}>Multiple Categories</h4>
            <p style={{ color: 'rgba(255, 255, 255, 0.8)', fontSize: '0.9rem' }}>
              Romantic, Luxury, Cute, Food & Treats, and Special occasion gifts
            </p>
          </div>
        </div>
      </div>

      {/* Pricing Strategy */}
      <div style={{
        maxWidth: '600px',
        margin: '30px auto 0',
        background: 'rgba(255, 255, 255, 0.05)',
        borderRadius: '20px',
        padding: '25px',
        textAlign: 'center'
      }}>
        <h3 style={{
          color: 'white',
          fontSize: '1.4rem',
          fontWeight: '700',
          marginBottom: '15px'
        }}>
          💰 Gift Pricing Strategy
        </h3>
        
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
          <div style={{
            background: 'rgba(149, 165, 166, 0.2)',
            borderRadius: '10px',
            padding: '12px'
          }}>
            <div style={{ fontSize: '1rem', color: '#95A5A6', fontWeight: '600' }}>🔘 Common</div>
            <div style={{ color: 'white', fontSize: '0.9rem' }}>10-25 coins</div>
          </div>
          
          <div style={{
            background: 'rgba(46, 204, 113, 0.2)',
            borderRadius: '10px',
            padding: '12px'
          }}>
            <div style={{ fontSize: '1rem', color: '#2ECC71', fontWeight: '600' }}>🟢 Uncommon</div>
            <div style={{ color: 'white', fontSize: '0.9rem' }}>25-45 coins</div>
          </div>
          
          <div style={{
            background: 'rgba(52, 152, 219, 0.2)',
            borderRadius: '10px',
            padding: '12px'
          }}>
            <div style={{ fontSize: '1rem', color: '#3498DB', fontWeight: '600' }}>🔵 Rare</div>
            <div style={{ color: 'white', fontSize: '0.9rem' }}>50-90 coins</div>
          </div>
          
          <div style={{
            background: 'rgba(155, 89, 182, 0.2)',
            borderRadius: '10px',
            padding: '12px'
          }}>
            <div style={{ fontSize: '1rem', color: '#9B59B6', fontWeight: '600' }}>🟣 Legendary</div>
            <div style={{ color: 'white', fontSize: '0.9rem' }}>100-300 coins</div>
          </div>
        </div>
      </div>

      {/* Recently Sent Gifts (Demo) */}
      {sentGifts.length > 0 && (
        <div style={{
          maxWidth: '800px',
          margin: '30px auto 0',
          background: 'rgba(255, 255, 255, 0.05)',
          borderRadius: '20px',
          padding: '25px'
        }}>
          <h3 style={{
            color: 'white',
            fontSize: '1.4rem',
            fontWeight: '700',
            marginBottom: '15px',
            textAlign: 'center'
          }}>
            🎁 Demo Sent Gifts
          </h3>
          
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center' }}>
            {sentGifts.slice(-5).map((gift, index) => (
              <div key={index} style={{
                background: 'rgba(255, 255, 255, 0.1)',
                borderRadius: '10px',
                padding: '8px 12px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                <span style={{ fontSize: '1.2rem' }}>{gift.emoji}</span>
                <span style={{ color: 'white', fontSize: '0.9rem' }}>{gift.name}</span>
                <span style={{ color: '#FFD700', fontSize: '0.8rem' }}>💎{gift.price}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      <style>{`
        @keyframes slideIn {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default GiftsDemo;